<i18n locale="en">
{
  "links": {
    "terms": "Terms of Use",
    "privacy": "Privacy Policy",
    "unsubscribe": "Unsubscribe",
    "owner": "Powered by Owner"
  }
}
</i18n>

<template>
  <PreviewSheet radius="0">
    <OwnStack>
      <PreviewSheet radius="0" class="pa-7" background="secondary">
        <span><!-- This is a gap between footer and content --></span>
      </PreviewSheet>
      <div v-if="hasLoyalty">
        <PreviewHr />
        <EmailLoyalty />
      </div>
      <PreviewHr />
      <OwnStack class="email-footer" spacing="4">
        <OwnStack row spacing="4" justify="center" align="center">
          <img src="/static/social-icons/instagram.svg" height="20" />
          <img src="/static/social-icons/facebook.svg" height="20" />
        </OwnStack>
        <OwnStack row spacing="4" justify="center" align="center">
          <PreviewTypographyLegacy
            :text="$t('links.terms')"
            color="secondary"
            variant="paragraphExtraSmall"
          />
          <PreviewTypographyLegacy
            :text="$t('links.privacy')"
            color="secondary"
            variant="paragraphExtraSmall"
          />
          <PreviewTypographyLegacy
            :text="$t('links.unsubscribe')"
            color="secondary"
            variant="paragraphExtraSmall"
          />
          <PreviewTypographyLegacy
            :text="$t('links.owner')"
            color="secondary"
            variant="paragraphExtraSmall"
          />
        </OwnStack>
        <OwnStack row spacing="4" justify="center" align="center">
          <img src="/static/app-stores/apple.svg" height="35" />
          <img src="/static/app-stores/google.svg" height="35" />
        </OwnStack>
      </OwnStack>
    </OwnStack>
  </PreviewSheet>
</template>

<script>
import { mapGetters } from 'vuex'

import { PreviewTypographyLegacy, PreviewHr, PreviewSheet } from '@/lib/builder'
import { OwnStack } from '@/ui'

import EmailLoyalty from './EmailLoyalty.vue'

export default {
  name: 'EmailFooter',
  components: {
    EmailLoyalty,
    OwnStack,
    PreviewHr,
    PreviewSheet,
    PreviewTypographyLegacy,
  },
  computed: {
    ...mapGetters({
      brand: 'brand/brand',
      campaign: 'emailBuilder/currentResource',
      getLocation: 'brand/locationById',
      locations: 'brand/locations',
    }),
    hasLoyalty() {
      const { campaign, getLocation, locations } = this
      if (!campaign) return false
      const { locationId } = campaign

      return locationId
        ? getLocation(locationId).features.loyalty
        : locations.some(({ features: { loyalty } }) => !!loyalty)
    },
  },
}
</script>

<style lang="scss" scoped>
.email-footer {
  padding: 40px;
}
</style>
